import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { Enums } from "../../../../helper/constants/enums";
import { getAllBulkProductsAction, updateBulkProductsAction } from "../../../actions/productsActions/bulkProductUpdate/bulkProductActions";
const INITIAL_STATE = {
    BulkProducts: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    UpdateBulkProductDetail: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }
};

const BulkProductReducer = createSlice({
    name: "BulkProduct",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetProductDetailsState(state, action) {
            state.UpdateBulkProductDetail = INITIAL_STATE.UpdateBulkProductDetail;
        },
        ResetProductDetailsgetallState(state, action) {
            state.BulkProducts = INITIAL_STATE.BulkProducts;
        },
    },

    extraReducers: (builder) => {

        builder.addCase(getAllBulkProductsAction.fulfilled, (state, action) => {
            state.BulkProducts.data = action.payload.data;
            state.BulkProducts.apiMsg.status = action.meta.requestStatus;
            state.BulkProducts.apiMsg.message = "success";
        });
        builder.addCase(getAllBulkProductsAction.pending, (state, action) => {
            state.BulkProducts.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllBulkProductsAction.rejected, (state, action) => {
            state.BulkProducts.apiMsg.message = action.error.message;
            state.BulkProducts.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(updateBulkProductsAction.fulfilled, (state, action) => {
            state.UpdateBulkProductDetail.data = action.payload.data;
            state.UpdateBulkProductDetail.apiMsg.status = action.meta.requestStatus;
            state.UpdateBulkProductDetail.apiMsg.message = "success";
            toast.success(action.payload.data.message.message ? action.payload.data.message.message :"Product updated successfully", {
                position: "bottom-center",
                toastId: "success"
            });
        });
        builder.addCase(updateBulkProductsAction.pending, (state, action) => {
            state.UpdateBulkProductDetail.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(updateBulkProductsAction.rejected, (state, action) => {
            state.UpdateBulkProductDetail.apiMsg.message = action.error.message;
            state.UpdateBulkProductDetail.apiMsg.status = action.meta.requestStatus;

            toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                position: "bottom-center",
                toastId: "error"
            });
        });

    }
})

export const { RESET, ResetProductDetailsState, ResetProductDetailsgetallState } = BulkProductReducer.actions;
export default BulkProductReducer.reducer;